import { AlpineComponent } from 'alpinejs';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import EffectMaterial from './effect-material.esm.js';
import './effect-material.scss';

const CompetenceView = (): AlpineComponent => ({
  activeIndex: 0,

  init() {
    const slider = this.$root.querySelector('.swiper');
    const swiper = new Swiper(slider, {
      modules: [Navigation, EffectMaterial],
      effect: 'material',
      materialEffect: {
        slideSplitRatio: 0.2
      },
      slideToClickedSlide: true,
      slidesPerView: 1,
      breakpoints: {
        960: {
          slidesPerView: 2
        }
      },
      spaceBetween: -1,
      speed: 450,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });

    swiper.on('slideChange', () => {
      this.activeIndex = swiper.realIndex;
    });
  }
});

export default CompetenceView;
